import React from 'react';
import Aux from './Aux';
import { Col, Row } from 'react-bootstrap';

const loadingScreen = (props) => {
  let content = props.children;
  if(props.isLoading){
    content = (
      <Row className="justify-content-md-center">
        <Col sm={10}>
          <div className="loader loader-sm"></div>
          <div className="mt-2 text-center">{props.text}</div>
        </Col>
      </Row>
    );
  }


  return (
    <Aux>
      {content}
    </Aux>
  );

}

export default loadingScreen;